import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";
import 'sweetalert2/dist/sweetalert2.css';
import axiosInstance from '../../utilities/axiosInstance';
import { showAlert } from "../../components/AlertPopup";

function DocumentBulkUpload() {
    let [excelFile, setExcelFile] = useState(null);
    let [zipFile, setZipFile] = useState(null);
    const excelInputRef = useRef(null);
    const zipInputRef = useRef(null);

    let handleDownloadClick = () => {
        // Reference the Excel file in the public/template folder
        let excelFileUrl = process.env.PUBLIC_URL + `/Template/documentbulkuploadtemplate.xlsx`;
        // Create a dummy anchor element to trigger the download
        let anchor = document.createElement('a');
        anchor.href = excelFileUrl;
        anchor.download = `documentbulkuploadtemplate.xlsx`; // Set the desired file name
        anchor.style.display = 'none';
        // Append the anchor to the document and trigger a click event
        document.body.appendChild(anchor);
        anchor.click();
        // Remove the anchor from the document
        document.body.removeChild(anchor);
    };

    let isExcelFile = (file) => {
        return file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.name.endsWith('.xlsx');
    };

    let readExcelFile = (file) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = (e) => {
                let data = new Uint8Array(e.target.result);
                let workbook = XLSX.read(data, { type: 'array' });
                resolve(workbook);
            };
            reader.readAsArrayBuffer(file);
        });
    };

    const [excelFileName, setExcelFileName] = useState("");
    let handleFileChange = async (event) => {
        let file = event.target.files[0];
        if (file) {
            setExcelFileName(file.name);
            if (isExcelFile(file)) {
                try {
                    let workbook = await readExcelFile(file);
                    let sheetName = workbook.SheetNames[0];
                    let worksheet = workbook.Sheets[sheetName];
                    let range = XLSX.utils.decode_range(worksheet['!ref']);
                    if (range.e.r >= range.s.r + 1) {
                        for (let rowIndex = range.s.r + 2; rowIndex <= range.e.r; rowIndex++) {
                            let requiredColumns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
                            let isRowValid = requiredColumns.every(column => {
                                let cell = worksheet[XLSX.utils.encode_cell({ r: rowIndex, c: column.charCodeAt(0) - 65 })];
                                return cell && cell.v !== undefined && cell.v !== null && cell.v.toString().trim() !== '';
                            });
                            if (!isRowValid) {
                                console.log(`Row ${rowIndex + 1} has missing values in required columns.`);
                                alert(`Please fill all required columns (A, B, D, E, F, G, H, I) for row ${rowIndex + 1} in the Excel file.`);
                                return; // Stop processing further rows if any row is invalid
                            }
                        }
                        setExcelFile(file);
                    } else {
                        alert('Not enough data rows found below the headers. <br/> Please upload a valid Excel file with data.');
                    }
                } catch (error) {
                    alert('An error occurred while processing the Excel file.');
                    console.error(error);
                }
            } else {
                alert('Please upload a valid Excel file with data.');
                // Clear the file input field
                event.target.value = '';
            }
        }
    };

    const [zipFileName, setZipFileName] = useState("");

    let handleZipFileChange = (event) => {
        let file = event.target.files[0];
        if (file) {
            setZipFileName(file.name);
            let allowedExtensions = ['.zip'];
            let fileName = file.name.toLowerCase();
            let isValidExtension = allowedExtensions.some(extension => fileName.endsWith(extension));
            if (isValidExtension) {
                setZipFile(file);
            } else {
                alert('Please select a valid ZIP file');
                // Clear the file input field
                event.target.value = '';
            }
        }
    };

    /*let showAlert = (arg, icon = 'info') => {
        Swal.fire({
            title: arg,
            text: arg,
            icon: icon,
            confirmButtonText: 'OK',
        });
    };*/

    let handleUploadClick = async (e) => {
        console.log(e.target.id);
        if (excelFile && zipFile) {
            try {
                let workbook = await readExcelFile(excelFile);
                let sheetName = workbook.SheetNames[0];
                let worksheet = workbook.Sheets[sheetName];
                let excelData = XLSX.utils.sheet_to_json(worksheet);

                // Convert date strings to YYYY-MM-DD format
                let formattedExcelData = excelData.map(item => ({
                    "project_name": item.project_name,
                    "assignNameOftaggers": item.assignNameOftaggers
                }));

                let formDataExl = new FormData();
                formDataExl.append('excelData', JSON.stringify(excelData))
                await axiosInstance.post(`/v2/excelupload`, formDataExl, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }).then(async (resExcel) => {
                    console.log(resExcel);
                    try {
                        let formData = new FormData();
                        formData.append('zipFileDoc', zipFile);
                        formData.append('body', JSON.stringify(excelData));
                        formData.append('insertedIds', JSON.stringify(resExcel.data.insertedIds));
                        await axiosInstance.post(`/doc-zip-extraction`, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }).then((resZip) => {
                            showAlert(resZip.data, 'success');
                        }).catch(async (error) => {
                            showAlert(error.response.data.message, 'error');
                            await axiosInstance.delete(`/delZipTask`, {
                                data: {
                                    details: formattedExcelData
                                }
                            }).then((delRes) => {
                                console.log("Data has been deleted");
                                setExcelFile(null);
                                setZipFile(null);
                            }).catch(error => {
                                console.log(error);
                            });
                        });
                    } catch (error) {
                        console.error('Error during upload:', error);
                    }
                }).catch(error => {
                    // Handle the error, e.g., display an error message to the user
                    console.error('Upload failed:', error);
                    showAlert(error, 'error');
                });
            } catch (error) {
                // Handle the error, e.g., display an error message to the user
                console.error('Error during upload:', error);
            }
        } else {
            alert('Please select both an Excel file and a ZIP file before uploading.');
        }
    };

    useEffect(() => {
    }, [excelFile]);

    useEffect(() => {
    }, [zipFile]);

    return (
        <div className='max-w-[650px] mx-auto mt-5'>
            <div className='flex items-center'>
                <button
                    id="downloadTopButton"
                    className="w-[300px] h-[60px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
                    onClick={handleDownloadClick}
                >
                    Download Documents Template
                </button>
            </div>
            <div>
                <span className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                    Upload the Excel:
                </span>

                <div className="relative w-full mt-[5px] mb-[20px]">
                    <div className="w-full h-[40px] flex items-center rounded-[22px] bg-white border border-gray-300 shadow-sm font-poppins text-[15px] text-gray-main overflow-hidden">

                        {/* Button on the left */}
                        <button
                            type="button"
                            onClick={() => excelInputRef.current?.click()}
                            className="h-full w-40 bg-deep-blue text-white px-4 font-poppins text-[15px] hover:bg-deep-blue focus:outline-none"
                        >
                            Choose File
                        </button>

                        {/* File name to the right */}
                        <span className="pl-4 pr-5 truncate w-full">
                            {excelFileName || "No file chosen"}
                        </span>
                    </div>

                    {/* Hidden actual input */}
                    <input
                        type="file"
                        accept="*"
                        onChange={handleFileChange}
                        ref={excelInputRef}
                        className="hidden"
                    />
                </div>
            </div>

            <div>
                <span className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                    Upload the ZIP:
                </span>

                <div className="relative w-full mt-[5px] mb-[20px]">
                    <div className="w-full h-[40px] flex items-center rounded-[22px] bg-white border border-gray-300 shadow-sm font-poppins text-[15px] text-gray-main overflow-hidden">

                        {/* Button on the left */}
                        <button
                            type="button"
                            onClick={() => zipInputRef.current?.click()}
                            className="h-full w-40 bg-deep-blue text-white px-4 font-poppins text-[15px] hover:bg-deep-blue focus:outline-none"
                        >
                            Choose File
                        </button>

                        {/* File name to the right */}
                        <span className="pl-4 pr-5 truncate w-full">
                            {zipFileName || "No file chosen"}
                        </span>
                    </div>

                    {/* Hidden file input */}
                    <input
                        type="file"
                        accept=".zip"
                        onChange={handleZipFileChange}
                        ref={zipInputRef}
                        className="hidden"
                    />
                </div>
            </div>
            {/* Upload button at the bottom */}
            <div className="flex justify-center">
                <button
                    id="uploadImageButton"
                    className="w-[150px] h-[60px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
                    onClick={handleUploadClick}
                >
                    Upload
                </button>
            </div>
        </div>
    );

}//End of function

export default DocumentBulkUpload;
